import React, { ButtonHTMLAttributes } from "react";
import "./Button.scss";

interface IProps extends ButtonHTMLAttributes<any> {
    variant?: 'primary' | 'secondary' | 'yellow'
    pulsate?: boolean
    wrapperClassName?: string;
}

export function Button(props: IProps) {
    let {
        className,
        wrapperClassName,
        variant = 'primary',
        pulsate = false,
        ...otherProps
    } = props;
    className = `button variant-${variant} ${className}`

    const buttonElement = React.createElement('button', {
        className,
        ...otherProps,
    });

    if (pulsate) {
        return <div className={`pulsate-button-wrapper ${wrapperClassName ?? ''} variant-${variant}`}>
            {buttonElement}
            <div className="pulse"/>
            <div className="pulse"/>
            <div className="pulse"/>
        </div>
    }

    return buttonElement;
}
